import { gql } from '@apollo/client';
const GETALLPLANS = gql`
  query getAllStripeProducts {
    getAllStripeProducts(connectedAccountId: "acct_1OKbGGBNPNagASFr")
  }
`;

export default GETALLPLANS;
